import zappy from "@zappy-ride/library.react.components";
import { ActionComponent } from "./ActionComponent";

export * from "./ActionComponent";

zappy.FactoryInstance.registerComponent(ActionComponent);
